import { Color } from './../models/color.model';
import { Observable } from 'rxjs';
import { ColorsApiService } from './../services/colors-api.service';
import { Injectable } from '@angular/core';


@Injectable()
export class ColorsManagerService {

    constructor(private colorsAPIService: ColorsApiService) { }

    getColors(accountId: number, type: number): Observable<Color[]> {
        return this.colorsAPIService.getColors(accountId, type);
    }

    addColor(accountId: number, createColorModel: Color): Observable<any> {
        return this.colorsAPIService.addColor(accountId, createColorModel);
    }

    deleteColor(id:number,type:number):Observable<any>
    {
        return this.colorsAPIService.deleteColor(id,type);
    }
}
